import { createSlice } from '@reduxjs/toolkit';
import { addComment } from '../actions/commentAction';

const initialState = {
  isLoading: false,
  error: null,
  success: null,
};

const commentSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    clearCommentState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addComment.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(addComment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload?.message || 'Comment added successfully';
      })
      .addCase(addComment.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || 'Failed to add comment';
      });
  },
});

export const { clearCommentState } = commentSlice.actions;
export default commentSlice.reducer; 